module.exports = __webpack_public_path__ + "img/belatra.c7cda00b.svg";